import { CustomStringParam, FilterType, SchemaFilterType } from '@ui/src';

export const linkedClientsColumnsItems = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'externalId',
    label: 'External ID',
    hidden: false,
    sortable: false,
  },
  {
    name: 'pspPartnerId',
    label: 'Bank',
    hidden: false,
    sortable: false,
  },
  {
    name: 'createdAt',
    label: 'Created',
    hidden: false,
    sortable: false,
  },
  {
    name: 'active',
    label: 'Status',
    hidden: false,
    sortable: false,
  },
];

export const linkedClientsColumnsLabels = {
  externalId: 'External ID',
  pspPartnerId: 'Bank',
};

export const linkedClientsSchema = {
  externalId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  pspPartnerId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
};

export const linkedClientsFiltersSchema = [
  {
    name: 'externalId',
    type: FilterType.TEXT,
    placeholder: 'Enter ID...',
  },
  {
    name: 'pspPartnerId',
    type: FilterType.AUTOCOMPLETE,
    placeholder: 'Select bank',
  },
];
